<template>

    <div v-if="view ==='init'"></div>

    <users-profile-component v-else-if="view === 'profile'" @user-initialised="trackUserPageView"></users-profile-component>

    <main-search-component v-else-if="view === 'search'"></main-search-component>

    <cms-routing-component v-else-if="view === 'cms'"></cms-routing-component>

    <not-found-component v-else-if="view === '404'"></not-found-component>

</template>

<script>

    import seoUrls from './mixins/seoUrls.js';
    import NotFoundComponent from "@/components/global/NotFoundComponent.vue";

    const data = () => {
        return {
            store: $store,
            view: 'init',
        }
    };

    function commitSeoView(value) {
        this.store.commit('setSeoView', value);
    }

    export default {
        components: {NotFoundComponent},
        data,
        created() {
            if (this.view === 'init') {
                this.refreshView();
            }
        },
        mixins: [
            seoUrls
        ],
        methods: {
            refreshView() {

                if (this.is404View) {
                    this.view = '404';

                    if (typeof xpv !== 'undefined') {
                        // track screen view 404
                        xpv(user, null, null, {srt: (xt.srt ? xt.srt : null)}, 404);
                    }

                    return;
                }

                if (typeof window === 'undefined') {
                    if (this.store.getters.getPreFetchedUser) {
                        this.view = 'profile';
                    } else if (this.store.getters.getCmsContent) {
                        this.view = 'cms';
                    } else {
                        this.view = 'search';
                    }
                } else {
                    this.view = this.getViewType();
                }
            },
            trackUserPageView(profileUser) {
                this.$emit('user-initialised', profileUser);

                if (typeof xpv === 'undefined') {
                    return;
                }

                if (!profileUser || !profileUser.id) {
                    return;
                }

                // The search tracking will track the search page view
                if (this.view === 'search') {
                    return;
                }

                // theoretically the event can be received if the page type is profile
                if (this.view !== 'profile') {
                    return;
                }

                let pageCategory = 'profile';
                let attributes = {
                    pid: profileUser.id,
                };

                let label = null;

                // in case, if the dynamic page view comes from promoted profiles section
                if (xt.pop) {
                    // s_pop is the previous promoted on profile results id
                    attributes.s_pop = xt.pop;
                    // pop is the new (current) promoted on profile results id
                    attributes.pop = profileUser.promoted_on_profile_results_id ? profileUser.promoted_on_profile_results_id : null;
                    label = 'from_promoted_on_profile';
                }

                // in case, if the dynamic page view comes from the search results
                if (xt.sch) {
                    attributes.srt = xt.srt;
                    attributes.s_sch = xt.sch;
                    label = 'from_search_results';
                }

                // in case, if the dynamic page view comes from the homepage results
                if (xt.hp) {
                    attributes.s_hp = xt.hp;
                    label = 'from_homepage';
                }

                // unset all tracking IDs because from label has been set
                xt.srt = null;
                xt.sch = null;
                xt.pop = null;
                xt.hp = null;

                xpv(user, null, pageCategory, attributes, null, label);
            }
        },
        watch: {
            view: commitSeoView,
            $route() {
                this.store.commit('setIs404View', false);
                this.refreshView()
            },
            is404View() {
                this.refreshView();
            }
        },
        computed: {
            ...mapState(['is404View'])
        }
    };
</script>
